import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';

// import { MatFormFieldModule } from '@angular/material';
import { CustomDirectiveModule } from '@directive/custom-directive.module';
import { CustomSearchSelectComponent } from './custom-searchselect.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    CustomDirectiveModule,
    AngularMultiSelectModule
  ],
  declarations: [
    CustomSearchSelectComponent
  ],
  exports: [
    CustomSearchSelectComponent
  ],
})

export class CustomSearchSelectModule { }
